/**
 * The dark surfaces of the analytics panel. Literals rather than theme tokens because the
 * panel is painted on the play stage's own dark chrome, which the design system's
 * background scales — built for a light canvas — have no entry for.
 *
 * ponytail: promote to a theme token if the play chrome ever gets one.
 */
export const PANEL_SURFACE = '#22252B';

/** The empty half of a bar, behind whatever the answers filled in. */
export const PANEL_BAR_TRACK = '#4E5461';
